export const Socials=[
    {
        name:"LinkedIn",
        icon:"fa-brands fa-linkedin",
        link:"https://www.linkedin.com/in/tuana-bicakci"
    },
    {
        name:"Mail",
        icon:"fa-solid fa-envelope",
        link:"mailto:bicakcituana@gmail.com"
    },
    {
        name:"GitHub",
        icon:"fa-brands fa-github",
        link:"https://github.com/tuanabicakci"
    },
    {
        name:"Itch.io",
        icon:"fa-brands fa-itch-io",
        link:"https://tuanabicakci.itch.io/"
    },
    {/*
    {
        name:"ArtStation",
        icon:"fa-brands fa-artstation",
        link:"https://www.artstation.com/tuanabicakci"
    },*/}
]